import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Controller, useForm, SubmitHandler } from "react-hook-form";
import slugify from "slugify";
import Select from 'react-select';

//constants
import { queryStrStart, queryStr1StParty, queryStr2NdParty, urlAssets, urlEspecial } from '../../Constants';

//types
import { DataByDistrict, CandidateData } from '../../types/types';
import Candidate from './Candidate';

type HomeContentProps = {
    data: DataByDistrict[];
}

type CandidateOption = {
    image: string;
    label: string;
    value: number;
}

type FormData = {
    party1: CandidateOption;
    party2: CandidateOption;
};

const HomeContent = ({ data }: HomeContentProps) => {

    const { control, handleSubmit, formState: { dirtyFields, errors }, watch } = useForm<FormData>();

    const defaultSelectedItem: number = -1; 
    const defaultCandidateValue: CandidateOption = { image: "", label: "Seleccionar", value: defaultSelectedItem };

    const defaultCandidateData: CandidateData = {
        name: 'Ánfora',
        party: '',
        showCandidateData: false,
        urlImageCandidate: `${urlAssets}img/bg-voto.svg`,
    }

    const [candidate1, setCandidate1] = useState<CandidateData>(defaultCandidateData);
    const [candidate2, setCandidate2] = useState<CandidateData>(defaultCandidateData);

    const [selectedCandidate1, setSelectedCandidate1] = useState<CandidateOption>(defaultCandidateValue);
    const [selectedCandidate2, setSelectedCandidate2] = useState<CandidateOption>(defaultCandidateValue);

    const handleChangeCandidate1 = (option: CandidateOption | null) => {
        if(option !== null){

            const partyData1: DataByDistrict = data[option.value];

            setSelectedCandidate1(candidates[option.value]);
            setCandidate1({
                name: partyData1.Candidato,
                party: partyData1.Partido,
                showCandidateData: true,
                urlImageCandidate: `${urlAssets}img/candidatos/${slugify((partyData1.Candidato).toLowerCase())}.png`
            });
        } 
    }

    const handleChangeCandidate2 = (option: CandidateOption | null) => {
        if(option !== null){

            const partyData2: DataByDistrict = data[option.value];
            
            setSelectedCandidate2(candidates[option.value]);
            setCandidate2({
                name: partyData2.Candidato,
                party: partyData2.Partido,
                showCandidateData: true,
                urlImageCandidate: `${urlAssets}img/candidatos/${slugify((partyData2.Candidato).toLowerCase())}.png`
            });
        } 
    }

    const getCandidates = () => {

        var candidates: CandidateOption[] = [];

        data.map(d => {
            return candidates = [...candidates, {                    
                    image: `${urlAssets}img/partidos/${slugify((d.Partido).toLowerCase())}.png`,
                    label: d.Candidato,                    
                    value: (parseInt(d.__rowNum__) - 1)
                }];
        });
        
        return candidates;
    }

    const candidates = getCandidates();

    const onSubmit: SubmitHandler<FormData> = data => {
        
        if(errors){
            const { party1, party2 }: FormData = data;
            window.location.replace( `${urlEspecial}${queryStrStart}${queryStr1StParty}=${party1}&${queryStr2NdParty}=${party2}`);
        }
    };

    return (
        <section className="mb-5 mx-auto px-2 px-md-0 content-parties">
            <form onSubmit={handleSubmit(onSubmit)}>
                <section className="mx-auto my-2 content-parties text-center">
                    <span className="d-inline-block my-2 text-grey-home choose">Candidato 1</span>
                    <section className="d-flex justify-content-center flex-wrap">
                    <Controller
                        control={control}
                        defaultValue={defaultCandidateValue}
                        name="party1"
                        rules={{ 
                            required: "Debes elegir un candidato",
                            min: {
                                value: 0,
                                message: "Debes elegir un candidato"
                            },
                            validate: {
                                isValidCandidateValue: val => (val.value !== defaultCandidateValue.value ) || "Debes elegir un candidato",
                                notEqualTo: val => (watch('party2') !== val || 'No pueden compararse los mismos candidatos')
                            }
                        }}
                        render={({ field: { onChange, name, ref } }) => {

                            const handleSelectChangeCandidate1 = (selectedOption: CandidateOption | null) => {
                                onChange((selectedOption !== null) && selectedOption.value);
                                handleChangeCandidate1(selectedOption);                                
                            };

                            return (
                                <Select 
                                    ref={ref}
                                    placeholder="Seleccionar"
                                    name={name}
                                    className="w-100 text-start form-select-option"
                                    options={candidates}
                                    onChange={handleSelectChangeCandidate1}
                                    noOptionsMessage={({inputValue}) => !inputValue && 'No se encontraron candidatos'} 
                                    value={selectedCandidate1}
                                    defaultValue={defaultCandidateValue}
                                    formatOptionLabel={candidateByDistrict => 
                                        <div className="d-flex align-items-center">
                                            {candidateByDistrict.image &&
                                                <LazyLoadImage                                        
                                                    alt={candidateByDistrict.label}
                                                    className="logo-party-option me-2 mb-1"
                                                    effect="blur"
                                                    src={candidateByDistrict.image}
                                                />
                                            }
                                            <span>{candidateByDistrict.label}</span>
                                        </div>
                                    }
                                />);
                            }}
                        />
                        {errors.party1 && <span className="d-inline-block pt-2 text-danger choose">{errors.party1.message}</span>}
                    </section>    
                </section> 
                <section className="mx-auto my-2 content-parties text-center">
                    <span className="d-inline-block my-2 text-grey-home choose">Candidato 2</span>
                    <section className="d-flex justify-content-center flex-wrap">
                    <Controller
                        control={control}
                        defaultValue={defaultCandidateValue}
                        name="party2"
                        rules={{ 
                            required: "Debes elegir un candidato",
                            min: {
                                value: 0,
                                message: "Debes elegir un candidato"
                            },
                            validate: {
                                isValidCandidateValue: val => (val.value !== defaultCandidateValue.value ) || "Debes elegir un candidato",
                                notEqualTo: val => (watch('party1') !== val || 'No pueden compararse los mismos candidatos')
                            }
                        }}
                        render={({ field: { onChange, name, ref } }) => {

                            const handleSelectChangeCandidate2 = (selectedOption: CandidateOption | null) => {
                                onChange((selectedOption !== null) && selectedOption.value);
                                handleChangeCandidate2(selectedOption);
                            };

                            return (
                                <Select 
                                    ref={ref}
                                    placeholder="Seleccionar"
                                    name={name}
                                    className="w-100 text-start form-select-option"
                                    options={candidates}
                                    onChange={handleSelectChangeCandidate2}
                                    noOptionsMessage={({inputValue}) => !inputValue && 'No se encontraron candidatos'} 
                                    value={selectedCandidate2}
                                    defaultValue={defaultCandidateValue}
                                    formatOptionLabel={candidateByDistrict => 
                                        <div className="d-flex align-items-center">
                                            {candidateByDistrict.image &&
                                                <LazyLoadImage                                        
                                                    alt={candidateByDistrict.label}
                                                    className="logo-party-option me-2 mb-1"
                                                    effect="blur"
                                                    src={candidateByDistrict.image}
                                                />
                                            }
                                            <span>{candidateByDistrict.label}</span>
                                        </div>
                                    }
                                />);
                            }}
                        />
                        {errors.party2 && <span className="d-inline-block pt-2 text-danger choose">{errors.party2.message}</span>}
                    </section>    
                </section> 
                <section className="row mx-auto mt-3 mb-2 content-parties text-center">
                    <Candidate 
                        candidate={candidate1}
                    />
                    <Candidate 
                        candidate={candidate2}
                    />
                </section>
                <section className="mx-auto mt-4 mb-2 content-parties text-center">
                    <button
                        disabled={((Object.keys(dirtyFields)).length === 2 ) ? false : true}
                        className="btn btn-dark rounded-0 px-4 px-md-5 py-2 btn-compare"
                    >
                        Comparar
                    </button>
                </section>
            </form>
        </section>
    )
}

export default HomeContent;